<template>
    <div class="articles-list">
        <div class="row" v-for="i in postsListRows" :key="i" >
            <post-component :post="posts[(i - 1) * 2]"></post-component>
            <post-component v-if="posts[(i - 1) * 2 + 1]" :post="posts[(i-1)*2+1]"></post-component>
        </div>
    </div>
</template>

<script>
    import PostComponent from "./Post";

    export default {
        name: 'posts-list',
        components: {PostComponent},
        props: {
            posts: {
                type: Array,
                default: () => {
                return []
                },
            },
        },
        computed: {
            postsListRows() {
                return Math.round(this.posts.length / 2);
            },
        },
    }

</script>

<style scoped>

</style>
